module.exports = __webpack_public_path__ + "media/Afterwar (Marcus and Aluna).1b4d79f5.mp3";